require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./miss-piggy-makes-her-bacon.json") })
        }
      }, "path---miss-piggy-makes-her-bacon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---miss-piggy-makes-her-bacon!./.cache/json/miss-piggy-makes-her-bacon.json
// module id = 399
// module chunks = 231608221292675